import { render, staticRenderFns } from "./DraggablePan.vue?vue&type=template&id=150aaa77"
import script from "./DraggablePan.vue?vue&type=script&setup=true&lang=ts"
export * from "./DraggablePan.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports